import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { appActions } from '../../../../store/modules/app';
import withModal from '../../../../lib/hoc/withModal';
import GeneratePointValidSuccessModal from '../../../../views/app/common/modal/GeneratePointValidSuccessModal';

/**
 *  포인트 발급 유효 체크 성공 모달
 */
class GeneratePointValidSuccessModalContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      memo: null,
    };
  }

  /**
   *  포인트 발급
   */
  onSubmit = () => {
    const { generatePoint, data } = this.props;
    const { memo } = this.state;
    const { userPointList, impossibleCnt, targetAction } = data;

    generatePoint({
      userPointList,
      impossibleCnt,
      targetAction,
      memo,
    });

    this.closeModal();
  };

  /**
   * 데이터 변경
   */
  setData = (data) => {
    this.setState({
      [data.name]: data.value,
    });
  };

  /**
   * 모달 닫기
   */
  closeModal = () => {
    this.props.appToggleModal({ name: 'generatePointValidSuccessModal', value: false });
  };

  render() {
    const { isOpen, data, form } = this.props;
    const { memo } = this.state;

    return (
      <GeneratePointValidSuccessModal
        isOpen={isOpen}
        data={data}
        form={form}
        memo={memo}
        setData={this.setData}
        onSubmit={this.onSubmit}
        closeModal={this.closeModal}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.app.generatePointValidSuccessModal.isOpen,
    data: state.app.generatePointValidSuccessModal.data,
  };
};

const mapDispatchToProps = {
  appToggleModal: appActions.appToggleModal,
  generatePoint: appActions.generatePoint,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Form.create()(withModal()(GeneratePointValidSuccessModalContainer)));
